// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeometryType } from "./GeometryType";
import {
  GeometryTypeFromJSON,
  GeometryTypeFromJSONTyped,
  GeometryTypeToJSON,
  GeometryTypeToJSONTyped,
} from "./GeometryType";

/**
 *
 * @export
 * @interface SchematisationVectorLayer
 */
export interface SchematisationVectorLayer {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  type: GeometryType;
}

/**
 * Check if a given object implements the SchematisationVectorLayer interface.
 */
export function instanceOfSchematisationVectorLayer(
  value: object
): value is SchematisationVectorLayer {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function SchematisationVectorLayerFromJSON(json: any): SchematisationVectorLayer {
  return SchematisationVectorLayerFromJSONTyped(json, false);
}

export function SchematisationVectorLayerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SchematisationVectorLayer {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    type: GeometryTypeFromJSON(json["type"]),
  };
}

export function SchematisationVectorLayerToJSON(json: any): SchematisationVectorLayer {
  return SchematisationVectorLayerToJSONTyped(json, false);
}

export function SchematisationVectorLayerToJSONTyped(
  value?: SchematisationVectorLayer | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    type: GeometryTypeToJSON(value["type"]),
  };
}
